import React, {Fragment} from 'react';

import ExperienceSamplingBanner from './ExperienceSamplingBanner';
import Questionnaires from './Questionnaires';

const Index = () => (
    <Fragment>
        <ExperienceSamplingBanner />
        <Questionnaires />
    </Fragment>
);

export default Index;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/Index.js